module.exports = __webpack_public_path__ + "assets/img/Light.997e6345.svg";